module.exports = __webpack_public_path__ + "img/grammar-post-it-notes-with-cofee-cup.5109b005.jpg";